"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isModifiedDate = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var isModifiedDate = function (day, modifiers) {
    if (!modifiers) {
        return false;
    }
    var arr = Array.isArray(modifiers) ? modifiers : [modifiers];
    return arr.some(function (mod) {
        if (!mod) {
            return false;
        }
        if (mod instanceof Date) {
            return (0, dayjs_1.default)(day).isSame(mod);
        }
        if (mod.after) {
            return (0, dayjs_1.default)(day).isAfter(mod.after);
        }
        if (mod.before) {
            return (0, dayjs_1.default)(day).isBefore(mod.before);
        }
        if (mod.daysOfWeek) {
            return mod.daysOfWeek.some(function (dayOfWeek) { return day.getDay() === dayOfWeek; });
        }
        return false;
    });
};
exports.isModifiedDate = isModifiedDate;
